import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Table, Card, Col, Form, Row } from "react-bootstrap";
import { IconPlus } from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DynamicPagination from "../../components/DynamicPagination ";
import moment from "moment";
import { useFormContext, useFieldArray, get } from "react-hook-form";
import { toast } from "react-toastify";
import AddQuickbookVendor from "./AddQuickbookVendor";
function SkuSearchPopUp({
  show,
  setShow,
  setSearchProps,
  onAddSku,
  searchProps,
  setCardSearch,
  cardSearch,
  calculateCosts,
  updateTextArea,
  ordertype,
}) {
  const [page, setPage] = useState(1);

  const [limit, setLimit] = useState(10);

  const [fetchedData, setFetchedData] = useState(null);
  const [showVendorPopup, setShowVendorPopup] = useState(false);
  const [vendorSkuId, setVendorSkuId] = useState(null);
  const [quickbookVendor, setQuickbookVendor] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [searchDebounce, setSearchDebounce] = useState({
    searchSku: "",
    productName: "",
    searchDescription: "",
    searchVendor: "",
    contract_type: "",
    variant: "",
  });

  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (searchProps) {
      setSearchDebounce({
        searchSku: searchProps.searchSku || "",
        productName: searchProps.productName || "",
        searchDescription: searchProps.searchDescription || "",
        searchVendor: searchProps.searchVendor || "",
        contract_type: searchProps.ContractName || "",
      });
    }
  }, [searchProps]);

  const handleAddClick = (product) => {
    const cardsss = getValues("cards");

    const currentValues = getValues("cards") || [];
    // const isDuplicate = currentValues.some(
    //   (item, idx) =>
    //     item?.skuIdUnique === product?.sku_id && idx !== searchProps.indexIs
    // );
    // if (isDuplicate) {
    //   toast.error(`Product with SKU ${product.sku_id} already exists.`);
    //   return;
    // }

    if (searchProps.indexIs !== undefined) {
      if (product?.Vendor === null) {
        console.log(
          "Product vendor is null. Here's the product data new console:",
          product,
        );
        setVendorSkuId(product?.sku_id);
        setShowVendorPopup(true);
        setSelectedProduct(product);
        return;
      }

      setValue(`cards[${searchProps.indexIs}].cost`, product?.aspetto_price, {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].productName`, product?.name, {
        shouldValidate: true,
      });
      setValue(
        `cards[${searchProps.indexIs}].vendorPartner`,
        product?.Vendor?.display_name,
        { shouldValidate: true },
      );
      setValue(
        `cards[${searchProps.indexIs}].skuId`,
        product?.sku_display_name,
        {
          shouldValidate: true,
        },
      );
      setValue(`cards[${searchProps.indexIs}].skuIdUnique`, product?.sku_id, {
        shouldValidate: true,
      });

      setValue(
        `cards[${searchProps.indexIs}].skuDescription`,
        product?.description_sales,
        {
          shouldValidate: true,
        },
      ); // Description update
      setValue(
        `cards[${searchProps.indexIs}].purchase_description`,
        product?.description,
        {
          shouldValidate: true,
        },
      ); // Description update

      setValue(
        `cards[${searchProps.indexIs}].internalSku`,
        product?.internal_id || product?.vendor_sku,
        {
          shouldValidate: true,
        },
      );
      setValue(
        `cards[${searchProps.indexIs}].variantId`,
        product?.variant_id || product?.Product?.variant_id || 0,
        {
          shouldValidate: true,
        },
      );

      if (updateTextArea && searchProps.indexIs !== undefined) {
        updateTextArea(searchProps.indexIs, product?.description_sales); //description
      }

      setValue(`cards[${searchProps.indexIs}].um`, product?.uoi, {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].qty`, 1);
      setValue(
        `cards[${searchProps.indexIs}].customerCost`,
        product?.customer_price,
        { shouldValidate: true },
      );
      if (product?.customer_price === "0.00") {
        setValue(`cards[${searchProps.indexIs}].margin`, "8", {
          shouldValidate: true,
        });
      }
      // setValue(
      //     `cards[${searchProps.indexIs}].margin`,
      //     product?.margin_percent,
      //     { shouldValidate: true }
      // );

      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[searchProps.indexIs] = {
        ...updatedCardSearch[searchProps.indexIs],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);
      calculateCosts();
      toast.success(`Product ${product.sku_id} is added successfully`);

      if (
        !searchProps.searchSku &&
        !searchProps.productName &&
        !searchProps.searchDescription &&
        !searchProps.searchVendor
      ) {
        // console.log("first");
        const updatedCards = getValues("cards");
        const nextBlankIndex = updatedCards.findIndex(
          (card) => !card.skuIdUnique && !card.cost && !card.skuDescription,
        );
        setSearchProps({
          searchSku: "",
          productName: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: searchProps.ContractName
            ? searchProps.ContractName
            : "",
          indexIs: nextBlankIndex !== -1 ? nextBlankIndex : undefined,
        });
      }

      const updatedCards = getValues("cards");
    } else {
      onAddSku(product);
      //calculateCosts()
    }
    // toast.success(
    //   `Added Successfully Product ${product.sku_id} is added successfully`
    // );
  };

  const handleQuickbookVendor = (quickbookVendor, selectedProduct) => {
    console.log(
      "the initial product add popup function in popup file triggered",
    );
    setValue(
      `cards[${searchProps.indexIs}].cost`,
      selectedProduct?.aspetto_price,
      {
        shouldValidate: true,
      },
    );
    setValue(`cards[${searchProps.indexIs}].vendorPartner`, quickbookVendor, {
      shouldValidate: true,
    });
    setValue(
      `cards[${searchProps.indexIs}].skuIdUnique`,
      selectedProduct?.sku_id,
      {
        shouldValidate: true,
      },
    );
    setValue(
      `cards[${searchProps.indexIs}].skuId`,
      selectedProduct?.sku_display_name,
      {
        shouldValidate: true,
      },
    );

    setValue(
      `cards[${searchProps.indexIs}].skuDescription`,
      selectedProduct?.description_sales,
      { shouldValidate: true },
    );
    setValue(
      `cards[${searchProps.indexIs}].purchase_description`,
      selectedProduct?.description,
      { shouldValidate: true },
    );

    if (updateTextArea && searchProps.indexIs !== undefined) {
      updateTextArea(searchProps.indexIs, selectedProduct?.description);
    }

    setValue(`cards[${searchProps.indexIs}].um`, selectedProduct?.uoi, {
      shouldValidate: true,
    });
    setValue(`cards[${searchProps.indexIs}].qty`, 1);
    setValue(
      `cards[${searchProps.indexIs}].customerCost`,
      selectedProduct?.customer_price,
      { shouldValidate: true },
    );
    if (selectedProduct?.customer_price === "0.00") {
      setValue(`cards[${searchProps.indexIs}].margin`, "8", {
        shouldValidate: true,
      });
    }
  };

  useEffect(() => {
    if (quickbookVendor && selectedProduct) {
      handleQuickbookVendor(quickbookVendor, selectedProduct);
      setSelectedProduct(null);
    }
  }, [quickbookVendor]);

  const handleSKUSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchSku: e.target.value,
    }));
    setPage(1);
  };
  const handleDescriptionSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchDescription: e.target.value,
    }));
  };

  const handleContractSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      contract_type: e.target.value,
    }));
  };

  const handleVendorSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchVendor: e.target.value,
    }));
  };

  const handleProductSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      productName: e.target.value,
    }));
  };

  const handleVariantSearch = (e) => {
    setSearchDebounce((prev) => ({ ...prev, variant: e.target.value }));
    // setPage(1);
  };

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
  };

  const { debounceSearch } = useDebounce(searchDebounce);

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  useEffect(() => {
    fetchProductSearch({
      page,
      limit,
      module_type: "RFQ",
      // abbreviation: getValues("code") || undefined,
      is_variant: true,
      order_status: ordertype,
      product_name:
        searchDebounce?.productName?.length > 0
          ? searchDebounce?.productName
          : undefined,
      sku:
        searchDebounce?.searchSku?.length > 0
          ? searchDebounce?.searchSku
          : undefined,
      vendor:
        searchDebounce?.searchVendor?.length > 0
          ? searchDebounce?.searchVendor
          : undefined,
      description:
        searchDebounce?.searchDescription?.length > 0
          ? searchDebounce?.searchDescription
          : undefined,
      contract_type:
        searchDebounce?.contract_type?.length > 0
          ? searchDebounce?.contract_type
          : undefined,
      variant: searchDebounce?.variant || null,
    });
  }, [page, limit, searchDebounce]);

  useEffect(() => {
    if (data && data.data) {
      setFetchedData(data);
    }
  }, [data]);

  const handleCloseModal = () => {
    setShow(false);
    setSearchDebounce({
      searchSku: "",
      productName: "",
      searchDescription: "",
      searchVendor: "",
      contract_type: "",
      variant: "",
    });
    setFetchedData(null);
  };

  useEffect(() => {
    console.log("quickbook vendor set is ", quickbookVendor);
  }, [quickbookVendor]);

  const handleVendorLinked = (vendorName) => {
    console.log("Vendor linked:", vendorName);
    setQuickbookVendor(vendorName);
  };

  return (
    <>
      {showVendorPopup && (
        <AddQuickbookVendor
          show={showVendorPopup}
          onClose={() => setShowVendorPopup(false)}
          skuId={vendorSkuId}
          onVendorLinked={handleVendorLinked}
        />
      )}
      <Modal
        scrollable={true}
        show={show}
        onHide={handleCloseModal}
        className="skusearch"
        dialogClassName="modal-90vw"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Row className="w-100">
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Vendor"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchVendor}
                onChange={handleVendorSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Product Name"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.productName}
                onChange={handleProductSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By SKU ID"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchSku}
                onChange={handleSKUSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By Description"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchDescription}
                onChange={handleDescriptionSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By Contract Vehicle "
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.contract_type}
                onChange={handleContractSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Variant"
                autoComplete="off"
                value={searchDebounce.variant}
                onChange={handleVariantSearch}
              />
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <Table>
              <thead responsive>
                <tr>
                  <th></th>
                  <th>INTERNAL ID</th>
                  <th className="text-center">VENDOR</th>
                  <th className="text-center">PRODUCT NAME</th>
                  <th className="text-center">SKU ID</th>
                  <th className="text-center">DESCRIPTION</th>
                  <th className="text-center">COST</th>
                </tr>
              </thead>
              <tbody>
                {fetchedData &&
                  fetchedData?.data?.map((product, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span
                            onClick={() => handleAddClick(product)}
                            className="avatar bg-green-lt"
                          >
                            <IconPlus />
                          </span>
                        </td>
                        <td className="text-start">
                          {product?.internal_id || product?.vendor_sku}
                        </td>
                        <td className="text-center">
                          {product?.Vendor?.display_name}
                        </td>
                        <td className="text-center text-orange">
                          {product?.variant_name || product?.name || ""}
                        </td>
                        <td className="text-start text-orange">
                          {product?.variant_sku ||
                            product?.sku_display_name ||
                            ""}
                        </td>
                        <td className="text-center">
                          {product?.description?.length > 100
                            ? product.description.slice(0, 100) + "..."
                            : product.description}
                        </td>
                        <td className="text-center">
                          {product?.aspetto_price}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
          {data?.data?.length > 0 && (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SkuSearchPopUp;
